/**
 * Breadcrumbs components.
 * @module components/theme/Breadcrumbs/Breadcrumbs
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Breadcrumbs as ItaliaBreadcrumbs } from 'design-comuni-plone-theme/components/ItaliaTheme';

const Breadcrumbs = ({ pathname }) => {
  let brdc = ItaliaBreadcrumbs({ pathname: pathname });

  const content = useSelector((state) => state.content?.data);

  const CT_CustomBreadcrumbs = ['Pagina Argomento']; //don't display breadcrumbs for this content-types. They will be displayed by content-type view if needed.
  if (CT_CustomBreadcrumbs?.indexOf(content?.['@type']) >= 0) {
    return null;
  }
  return (
    <div className="public-ui">
      <section id="briciole" className="container">
        {brdc}
      </section>
    </div>
  );
};

Breadcrumbs.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Breadcrumbs;
